module.exports = __webpack_public_path__ + "static/media/my-scenes.24dfc1fb.svg";